<div class="pact-page">
  <div class="pact-page-head">
    <div>
      <h1 class="pact-title">{{ 'activity' | translate }}</h1>
      <p class="pact-subtitle">{{ 'classSocialFeedForParents' | translate }}</p>
    </div>
    <button class="pact-btn pact-btn-secondary" [disabled]="loading" (click)="loadFeed(1)">
      <i class="ri-refresh-line"></i> {{ 'refresh' | translate }}
    </button>
  </div>

  <div class="pact-feed-col">
    <div class="pact-card pact-post-card pact-skeleton-card" *ngIf="loading">
      <div class="pact-post-head">
        <div class="pact-avatar pact-post-avatar pact-skeleton pact-skeleton-circle"></div>
        <div class="pact-list-text">
          <div class="pact-skeleton pact-skeleton-line pact-skeleton-line-title"></div>
          <div class="pact-skeleton pact-skeleton-line pact-skeleton-line-sub"></div>
        </div>
      </div>
      <div class="pact-skeleton pact-skeleton-line pact-skeleton-line-text"></div>
      <div class="pact-skeleton pact-skeleton-line pact-skeleton-line-text-short"></div>
      <div class="pact-skeleton pact-skeleton-media"></div>
    </div>
    <div class="pact-card pact-post-card pact-skeleton-card" *ngIf="loading">
      <div class="pact-post-head">
        <div class="pact-avatar pact-post-avatar pact-skeleton pact-skeleton-circle"></div>
        <div class="pact-list-text">
          <div class="pact-skeleton pact-skeleton-line pact-skeleton-line-title"></div>
          <div class="pact-skeleton pact-skeleton-line pact-skeleton-line-sub"></div>
        </div>
      </div>
      <div class="pact-skeleton pact-skeleton-line pact-skeleton-line-text"></div>
      <div class="pact-skeleton pact-skeleton-line pact-skeleton-line-text-short"></div>
    </div>
    <div class="pact-card pact-post-card pact-skeleton-card" *ngIf="loading">
      <div class="pact-post-head">
        <div class="pact-avatar pact-post-avatar pact-skeleton pact-skeleton-circle"></div>
        <div class="pact-list-text">
          <div class="pact-skeleton pact-skeleton-line pact-skeleton-line-title"></div>
          <div class="pact-skeleton pact-skeleton-line pact-skeleton-line-sub"></div>
        </div>
      </div>
      <div class="pact-skeleton pact-skeleton-line pact-skeleton-line-text"></div>
      <div class="pact-skeleton pact-skeleton-media"></div>
    </div>

    <div class="pact-empty-state" *ngIf="!loading && loadError">
      <i class="ri-error-warning-line"></i> {{ 'couldntLoadActivityFeed' | translate }}
    </div>

    <div class="pact-empty-state" *ngIf="!loading && !loadError && posts.length === 0">
      <div class="pe-icon"><i class="ph ph-folder-open"></i></div>
      <div class="pe-title">{{ 'dataNotFound' | translate }}</div>
    </div>

    <div class="pact-card pact-post-card" *ngFor="let post of posts">
      <div class="pact-post-head">
        <div class="pact-avatar pact-post-avatar">
          <img *ngIf="postAuthorImage(post)" [src]="postAuthorImage(post)" alt="" />
          <ng-container *ngIf="!postAuthorImage(post)">{{ postAuthor(post).charAt(0) }}</ng-container>
        </div>
        <div class="pact-list-text">
          <div class="pact-post-title">{{ postAuthor(post) }}</div>
          <div class="pact-post-meta">{{ 'postedLabel' | translate }} {{ post.CreatedOn | date: 'dd MMM y, hh:mm a' }}</div>
        </div>
      </div>

      <div class="pact-post-text" [innerHTML]="postBodyHtml(post)"></div>

      <div class="pact-link-preview" *ngIf="postLink(post) as link" (click)="openLinkLightbox(link)">
        <div class="pact-link-thumb" *ngIf="linkPreview(link).isYouTube">
          <img [src]="linkPreview(link).thumbnail" alt="" />
          <div class="pact-link-play"><i class="ri-play-line"></i></div>
        </div>
        <div class="pact-link-thumb pact-link-thumb-generic" *ngIf="!linkPreview(link).isYouTube">
          <i class="ri-link"></i>
        </div>
        <div class="pact-link-info">
          <div class="pact-link-domain">{{ linkPreview(link).domain }}</div>
          <div class="pact-link-url">{{ link }}</div>
        </div>
      </div>

      <div class="pact-media-collage" *ngIf="hasMedia(post)" [class.pact-single-media]="!isCollage(post)" [ngClass]="isCollage(post) ? ('pact-collage-' + Math.min(visualMediaCount(post), 4)) : ''">
        <ng-container *ngFor="let m of allVisualMedia(post).slice(0,4); let i = index">
          <div class="pact-collage-tile" (click)="(i === 3 && extraMediaCount(post) > 0) ? openGallery(post) : openMediaPreview(m)">
            <img *ngIf="m.mediaType === 'IMAGE'" [src]="m.mediaUrl" class="pact-collage-img" alt="" />
            <video *ngIf="m.mediaType === 'VIDEO'" [src]="m.mediaUrl" class="pact-collage-img"></video>
            <div class="pact-collage-more-overlay" *ngIf="i === 3 && extraMediaCount(post) > 0">
              +{{ extraMediaCount(post) }}
            </div>
          </div>
        </ng-container>
      </div>
      <div class="pact-media-doc-row" *ngIf="postDocuments(post).length">
        <ng-container *ngFor="let d of postDocuments(post)">
          <a *ngIf="isPdfDocument(d) && pdfThumbnail(d.mediaUrl) as thumb; else docChip"
             (click)="openDocumentLightbox(d.mediaUrl)" href="javascript:void(0)" class="pact-media-doc-thumb">
            <img [src]="thumb" alt="{{ 'documentPreview' | translate }}" />
            <span class="pact-media-doc-thumb-label"><i class="ri-file-pdf-line"></i> {{ 'document' | translate }}</span>
          </a>
          <ng-template #docChip>
            <a (click)="openDocumentLightbox(d.mediaUrl)" href="javascript:void(0)" class="pact-media-doc-chip">
              <i class="ri-file-pdf-line"></i> {{ 'document' | translate }}
            </a>
          </ng-template>
        </ng-container>
      </div>

      <div class="pact-reaction-summary" *ngIf="postTotalLikes(post)" [class.pact-reaction-summary-static]="!getViewReactionFeatureEnabled"
        (click)="getViewReactionFeatureEnabled && openReactionList(post)">
        <span class="pact-reaction-icons">
          <span *ngFor="let icon of reactionIcons(post)">{{ icon }}</span>
        </span>
        {{ reactionSummaryText(post) }}
      </div>

      <div class="pact-post-footer">
        <div class="pact-reaction-wrap">
          <span class="pact-footer-stat" [class.pact-footer-stat-disabled]="!likeFeatureEnabled"
            (click)="likeFeatureEnabled && toggleReactionPicker(post)"
            (mouseenter)="likeFeatureEnabled && openReactionPickerOnHover(post)" (mouseleave)="scheduleReactionPickerClose()">
            <ng-container *ngIf="myReactionIcon(post) as icon; else defaultIcon">{{ icon }}</ng-container>
            <ng-template #defaultIcon><i [ngClass]="defaultReactionIcon"></i></ng-template>
            {{ postTotalLikes(post) }}
          </span>
          <div class="pact-reaction-picker" *ngIf="likeFeatureEnabled && openReactionPickerId === post.activityId" (mouseenter)="cancelReactionPickerClose()" (mouseleave)="scheduleReactionPickerClose()">
            <button class="pact-reaction-option" *ngFor="let r of reactions" [class.active]="isReactedByMe(post, r.slug)" (click)="reactToPost(post, r.slug)" title="{{ r.label }}">
              {{ r.icon }}
            </button>
          </div>
        </div>
        <span class="pact-footer-stat" *ngIf="getCommentFeatureEnabled || commentFeatureEnabled" (click)="openCommentSheet(post)">
          <i class="ri-chat-3-line"></i> {{ postCommentCount(post) }}
        </span>
      </div>
    </div>

    <div class="pact-load-more" *ngIf="!loading && posts.length && pageNumber < maxPageNumber">
      <button class="pact-btn pact-btn-secondary" [disabled]="loadingMore" (click)="loadMore()">
        {{ (loadingMore ? 'loadingEllipsis' : 'loadMore') | translate }}
      </button>
    </div>
  </div>
</div>

<!-- Reaction list modal -->
<div class="pact-modal-overlay" *ngIf="showReactionList" (click)="closeReactionList()">
  <div class="pact-modal" (click)="$event.stopPropagation()">
    <div class="pact-modal-head">
      <h3>{{ 'reactionsTitle' | translate }}</h3>
      <button class="pact-icon-btn" (click)="closeReactionList()"><i class="ri-close-line"></i></button>
    </div>
    <div class="pact-reaction-filter-row">
      <button class="pact-filter-chip" [class.active]="reactionListFilter === 'ALL'" (click)="setReactionFilter('ALL')">{{ 'all' | translate }}</button>
      <button class="pact-filter-chip" *ngIf="hasReactionsOfType('like')" [class.active]="reactionListFilter === 'like'" (click)="setReactionFilter('like')">👍 {{ reactionStats.like }}</button>
      <button class="pact-filter-chip" *ngIf="hasReactionsOfType('love')" [class.active]="reactionListFilter === 'love'" (click)="setReactionFilter('love')">❤️ {{ reactionStats.love }}</button>
      <button class="pact-filter-chip" *ngIf="hasReactionsOfType('laugh')" [class.active]="reactionListFilter === 'laugh'" (click)="setReactionFilter('laugh')">😄 {{ reactionStats.laugh }}</button>
      <button class="pact-filter-chip" *ngIf="hasReactionsOfType('celebration')" [class.active]="reactionListFilter === 'celebration'" (click)="setReactionFilter('celebration')">🎉 {{ reactionStats.celebration }}</button>
    </div>
    <div class="pact-modal-body">
      <ng-container *ngIf="reactionListLoading && reactionEntries.length === 0">
        <div class="pact-list-row" *ngFor="let i of [1,2,3,4]">
          <div class="pact-skeleton pact-skeleton-circle" style="width:38px;height:38px;"></div>
          <div class="pact-list-text">
            <div class="pact-skeleton pact-skeleton-line pact-skeleton-line-title"></div>
            <div class="pact-skeleton pact-skeleton-line pact-skeleton-line-sub"></div>
          </div>
        </div>
      </ng-container>
      <div class="pact-list-row" *ngFor="let r of reactionEntries">
        <div class="pact-avatar">
          <img *ngIf="r.likedByUserImage" [src]="r.likedByUserImage" alt="" />
          <ng-container *ngIf="!r.likedByUserImage">{{ r.likedByUserName.charAt(0) }}</ng-container>
        </div>
        <div class="pact-list-text">
          <div class="pact-list-title">{{ r.likedByUserName }}</div>
          <div class="pact-list-sub">{{ r.likedByUserDesignation }}</div>
        </div>
      </div>
      <div class="pact-empty-state" *ngIf="!reactionListLoading && reactionEntries.length === 0">{{ 'noReactionsYet' | translate }}</div>
    </div>
  </div>
</div>

<!-- Comment modal — centered overlay, matching the staff UI as-is -->
<div class="pact-modal-overlay" *ngIf="showComments" (click)="closeCommentSheet()">
  <div class="pact-modal pact-comment-sheet" (click)="$event.stopPropagation()">
    <div class="pact-modal-head">
      <h3>{{ 'comments' | translate }}</h3>
      <button class="pact-icon-btn" (click)="closeCommentSheet()"><i class="ri-close-line"></i></button>
    </div>
    <div class="pact-modal-body pact-comment-list">
      <ng-container *ngIf="commentsLoading && comments.length === 0">
        <div class="pact-comment-row" *ngFor="let i of [1,2,3]">
          <div class="pact-skeleton pact-skeleton-circle pact-comment-avatar"></div>
          <div class="pact-comment-bubble">
            <div class="pact-skeleton pact-skeleton-line pact-skeleton-line-title"></div>
            <div class="pact-skeleton pact-skeleton-line pact-skeleton-line-sub"></div>
          </div>
        </div>
      </ng-container>
      <div class="pact-comment-row" *ngFor="let c of comments">
        <div class="pact-avatar pact-comment-avatar">
          <img *ngIf="c.commentByUserImage" [src]="c.commentByUserImage" alt="" />
          <ng-container *ngIf="!c.commentByUserImage">{{ (c.commentByUserName || 'U').charAt(0) }}</ng-container>
        </div>
        <div class="pact-comment-bubble">
          <ng-container *ngIf="editingCommentId !== c.commentId">
            <div class="pact-comment-author">{{ c.commentByUserName || ('userFallback' | translate) }}</div>
            <div class="pact-comment-text">{{ c.comment }}</div>
          </ng-container>
          <div class="pact-comment-edit-row" *ngIf="editingCommentId === c.commentId">
            <input type="text" class="pact-comment-edit-input" [(ngModel)]="editingCommentText" (keyup.enter)="saveEditedComment()" />
            <button class="pact-icon-btn" (click)="saveEditedComment()"><i class="ri-check-line"></i></button>
            <button class="pact-icon-btn" (click)="cancelEditComment()"><i class="ri-close-line"></i></button>
          </div>
        </div>
        <div class="pact-comment-actions" *ngIf="editingCommentId !== c.commentId && (canEditComment(c) || canDeleteComment(c))">
          <button class="pact-icon-btn" *ngIf="canEditComment(c)" (click)="startEditComment(c)"><i class="ri-pencil-line"></i></button>
          <button class="pact-icon-btn" *ngIf="canDeleteComment(c)" (click)="deleteComment(c)"><i class="ri-delete-bin-line"></i></button>
        </div>
      </div>
      <div class="pact-empty-state" *ngIf="!getCommentFeatureEnabled && !commentFeatureEnabled">{{ 'commentingNotEnabled' | translate }}</div>
      <div class="pact-empty-state" *ngIf="!getCommentFeatureEnabled && commentFeatureEnabled">{{ 'commentsNotViewable' | translate }}</div>
      <div class="pact-empty-state" *ngIf="getCommentFeatureEnabled && !commentsLoading && comments.length === 0">{{ 'noCommentsYet' | translate }}</div>
      <div class="pact-load-more" *ngIf="getCommentFeatureEnabled && commentHasMore && comments.length">
        <button class="pact-btn pact-btn-secondary" [disabled]="commentsLoading" (click)="loadMoreComments()">
          {{ (commentsLoading ? 'loadingEllipsis' : 'loadMore') | translate }}
        </button>
      </div>
    </div>
    <div class="pact-modal-foot pact-comment-input-row" *ngIf="commentFeatureEnabled">
      <input type="text" placeholder="{{ 'writeACommentPlaceholder' | translate }}" [(ngModel)]="newComment" (keyup.enter)="submitComment()" />
      <button class="pact-btn pact-btn-primary" (click)="submitComment()"><i class="ri-send-plane-line"></i></button>
    </div>
  </div>
</div>

<!-- Delete comment confirmation — opened from within the comment modal, so
     it must stack above it. -->
<div class="pact-modal-overlay pact-modal-overlay-top" *ngIf="showDeleteCommentModal" (click)="closeDeleteCommentModal()">
  <div class="pact-modal pact-delete-modal" (click)="$event.stopPropagation()">
    <div class="pact-modal-head">
      <h3>{{ 'deleteCommentTitle' | translate }}</h3>
      <button class="pact-icon-btn" [disabled]="deletingComment" (click)="closeDeleteCommentModal()"><i class="ri-close-line"></i></button>
    </div>
    <div class="pact-modal-body">
      <div class="pact-delete-warning-icon"><i class="ri-error-warning-line"></i></div>
      <p class="pact-delete-warning-text">{{ 'sureDeleteComment' | translate }}</p>
      <p class="pact-delete-reason-hint">{{ 'deleteCannotBeUndone' | translate }}</p>
    </div>
    <div class="pact-modal-foot">
      <button class="pact-btn pact-btn-secondary" [disabled]="deletingComment" (click)="closeDeleteCommentModal()">{{ 'cancel' | translate }}</button>
      <button class="pact-btn pact-btn-danger" [disabled]="deletingComment" (click)="confirmDeleteComment()">
        <i class="ri-loader-4-line ri-spin" *ngIf="deletingComment"></i> {{ (deletingComment ? 'deletingEllipsis' : 'deleteCommentBtn') | translate }}
      </button>
    </div>
  </div>
</div>

<!-- In-app media / link lightbox — never navigates the user away -->
<div class="pact-lightbox-overlay" *ngIf="showLightbox" (click)="closeLightbox()">
  <button class="pact-lightbox-close" (click)="closeLightbox()"><i class="ri-close-line"></i></button>
  <div class="pact-lightbox-content" (click)="$event.stopPropagation()">
    <iframe *ngIf="lightboxType === 'document'" [src]="lightboxSafeUrl" class="pact-lightbox-frame"></iframe>
    <iframe *ngIf="lightboxType === 'link'" [src]="lightboxSafeUrl" class="pact-lightbox-frame"></iframe>
  </div>
</div>

<!-- Full-post view — opened from the collage. Shows the post's author, time
     and text like the feed card, plus every attached image/video stacked in
     a scrollable list. Clicking a media item opens a full-screen preview of
     just that item. -->
<div class="pact-gallery-overlay" *ngIf="showGallery" (click)="closeGallery()">
  <div class="pact-gallery-panel" (click)="$event.stopPropagation()">
    <div class="pact-gallery-head">
      <div class="pact-post-head pact-gallery-post-head" *ngIf="galleryPost">
        <div class="pact-avatar pact-post-avatar">
          <img *ngIf="postAuthorImage(galleryPost)" [src]="postAuthorImage(galleryPost)" alt="" />
          <ng-container *ngIf="!postAuthorImage(galleryPost)">{{ postAuthor(galleryPost).charAt(0) }}</ng-container>
        </div>
        <div class="pact-list-text">
          <div class="pact-post-title">{{ postAuthor(galleryPost) }}</div>
          <div class="pact-post-meta">{{ 'postedLabel' | translate }} {{ galleryPost.CreatedOn | date: 'dd MMM y, hh:mm a' }}</div>
        </div>
      </div>
      <button class="pact-icon-btn" (click)="closeGallery()"><i class="ri-close-line"></i></button>
    </div>
    <div class="pact-gallery-scroll">
      <div class="pact-post-text pact-gallery-post-text" *ngIf="galleryPost" [innerHTML]="postBodyHtml(galleryPost)"></div>
      <div class="pact-gallery-row" *ngFor="let m of galleryItems" (click)="openMediaPreview(m, $event)">
        <img *ngIf="m.mediaType === 'IMAGE'" [src]="m.mediaUrl" class="pact-gallery-row-media" alt="" />
        <video *ngIf="m.mediaType === 'VIDEO'" [src]="m.mediaUrl" class="pact-gallery-row-media"></video>
      </div>
    </div>
  </div>
</div>

<!-- Full-screen preview of a single media item, opened from the post view above -->
<div class="pact-lightbox-overlay" *ngIf="showMediaPreview" (click)="closeMediaPreview()">
  <button class="pact-lightbox-close" (click)="closeMediaPreview()"><i class="ri-close-line"></i></button>
  <div class="pact-lightbox-content" (click)="$event.stopPropagation()">
    <img *ngIf="previewItem?.mediaType === 'IMAGE'" [src]="previewItem?.mediaUrl" class="pact-lightbox-image" alt="" />
    <video *ngIf="previewItem?.mediaType === 'VIDEO'" [src]="previewItem?.mediaUrl" class="pact-lightbox-video" controls autoplay></video>
  </div>
</div>
